export enum HandleType {
    MinHandle = 1,
    MaxHandle = 2,
}

export interface IHandleProps {
    step: number;
    left: number | undefined;
}

export interface IHandleStyles {
    left: string;
    visibility: string;
}

export interface IRangeStyles {
    left: string;
    width: string;
}
